module.exports = __webpack_public_path__ + "static/media/example3.05feb613.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Layout/About/example3.gif
// module id = 1239
// module chunks = 2